// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressInfoBlock_container__q5Slu","name":"AddressInfoBlock_name__25ypn"};